
import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function moduloComboReducer(state= initialState.moduloCombo, action){
	switch(action.type){
		case types.GET_MODULOS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}